import { render } from "./Layout.vue?vue&type=template&id=334f0884"
import script from "./Layout.vue?vue&type=script&lang=js"
export * from "./Layout.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\grntm\\OneDrive\\Study\\Vue Mastery\\real-world-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__